export const TEMPLATE_NAME = {
  CANDY: 'Candy',
  HAIER: 'Haier',
  HAIER_TV: 'HaierTV',
  HAIER2: 'Haier2',
  HOOVER: 'Hoover',
  LENOVO: 'Lenovo',
  CANDY_SQUARE: 'Candy 2',
  SCHNEIDER_FD: 'FD',
  SCHNEIDER_PP: 'PP',
  SCHNEIDER_IA: 'IA',
  TEST_BRAND: 'Test Brand',
  CANDY3: 'Candy 3',
  CANDY4: 'Candy 4',
  DEMO: 'Demo'
}
